<template>
  <div class="activity-container">
    <div class="banner">
      <img class="title1" src="@/assets/images/activity/title1.png" alt="">
      <img class="title2" src="@/assets/images/activity/title2.png" alt="">
    </div>
    <div class="content-box">
      <div class="menu-list" >
        <div class="item" :class="{active: currentIndex == index}" @click="change(index)" v-for="(item, index) in menuList" :key="index">{{item}}</div>
      </div>
      <div class="vote-list" v-if="currentIndex == 0">
        <div class="item" v-for="(item, index) in voteList" :key="index" @click="toVote(item)">
          <!-- <img class="item-img" :src="item.shufflingUrl" alt=""> -->
          <div class="item-img" :style="{backgroundImage: `url(${item.shufflingUrl}?x-oss-process=image/resize,w_480)`}"></div>
          <div class="info">
            <div class="title">{{item.title}}</div>
            <div class="info-item">
              <img src="../../assets/images/activity/time.png" alt=""> {{item.voteStartTime && item.voteStartTime.split(' ')[0]}}至{{item.voteEndTime && item.voteEndTime.split(' ')[0]}}
            </div>
            <div class="info-item">
              <img src="../../assets/images/activity/hot.png" alt=""> 人气：{{item.num}}
            </div>
          </div>
        </div>
      </div>

      <div class="article-list" v-else>
        <div class="item" :style="{backgroundImage: `url(${item.coverIcon}?x-oss-process=image/resize,w_720)`}" v-for="(item, index) in articleList" :key="index" @click="toArticleDetail(item)">
          <!-- <img :src="item.coverIcon" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
	import {
		wxTools
  } from '@utils'
  import {
		setLocal,
		getLocal
	} from '@utils/tools'
export default {
  data() {
    return {
      menuList: ['全部活动', '活动动态'],
      currentIndex: 0,
      voteId:'',
      voteList: [],
      articleList: []
    }
  },
  methods: {
    change(index) {
      this.currentIndex = index
      // if (index = 0) {
      //   this.getVoteList()
      // } else {
      //   this.getArticleList()
      // }
    },
    isDuringDate(item) {
      item.voteStartTime
      item.voteEndTime
			var curDate = new Date().getTime()
				
			if (curDate < item.voteStartTimestamp) {
				this.$dialog.alert({
					title: '温馨提示',
					message: `投票开始时间还未到！将于 `+item.voteStartTime+` 开始投票！`,
				}).then(() => {
					
				});
				return false;
			}else if(curDate > item.voteEndTimestamp){
				this.$dialog.alert({
					title: '温馨提示',
					message: `投票时间已经于`+item.voteEndTime+' 结束！',
				}).then(() => {
					
				});
				return false;
			}
			return true;
		},
    toVote(item) {
      // if (this.isDuringDate(item)) {
        this.$router.push({
          path: '/lineVote',
          query: {
            voteCode: item.code
          }
        })
      // }
    },
    toArticleDetail(item) {
      this.$router.push({
        path: '/articleDetail',
        query: {
          id: item.id
        }
      })
    },
    // 获取投票列表
    getVoteList(){
      let param = {
        // voteId:voteId,
        pageNum:1,
        pageSize:1000
      }
      this.$api.activity.getVoteList(param,res=>{
        this.voteList = res.rows;
      })
    },
    // 获取文章列表
    getArticleList(){
      let param = {
        pageNum:1,
        pageSize:1000
      }
      this.$api.activity.getArticleList(param,res=>{
        this.articleList = res.rows;
      })
    }
  },
  created() {
    let token = localStorage.getItem('token')
    if (!token) {
      if (this.$route.query.code) {
        this.$api.user.getWxUser({
					code: this.$route.query.code
				}, res => {
          console.log(res.data.token)
					if(res.data && res.data.token && res.data.token != 'undefined'){
						localStorage.setItem('token', res.data.token)
					}
				})
      } else {
        new wxTools().getCode({
          securityUrl: window.location.href,
          state: ''
        })
      }
    }
  },
  mounted(){
    this.getVoteList()
    this.getArticleList()
  },
}
</script>

<style lang="scss" scoped>
.activity-container{
  width: 100vw;
  height: 100vh;
  background: #EBEBEB;
  
  .banner {
    width: 100%;
    height: 206px;
    background: url('../../assets/images/activity/banner.png');
    background-size: 100% 100%;
    text-align: center;

    .title1 {
      width: 249px;
      height: auto;
      margin-top: 40px
    }

    .title2 {
      width: 210px;
      height: auto;
      margin-top: -10px
    }
  }

  .content-box {
    border-radius: 15px 15px 0 0;
    background: #fff;
    padding-top: 20px;
    margin-top: -25px;

    .menu-list {
      display: flex;
      border-bottom: 6px solid #EBEBEB;
      padding-bottom: 5px;
      .item {
        width: 50%;
        text-align: center;
        color: #000000;
        font-size: 16px;
        position: relative;
      }

      .active::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -11px;
        transform: translate(-50%, 0);
        width: 59px;
        height: 6px;
        border-radius: 3px;
        background-color: #A35DF1
      }
    }

    .vote-list {
      .item {
        display: flex;
        align-items: center;
        padding: 10px 20px;
        border-bottom: 6px solid #EBEBEB;

        .item-img {
          width: 140px;
          height: 85px;
          margin-right: 20px;
          border-radius: 10px;
          background-size: cover;
          background-position: center;
        }

        .info {
          flex: 1;
          .title {
            font-size: 12px;
            color: #000000;
            margin-bottom: 15px;
          }

          .info-item {
            color: #676666;
            font-size: 10px;
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            img {
              margin-right: 8px;
              width: 16px;
              height: 16px
            }
          }
        }
      }
    }

    .article-list {
      padding: 0 20px 20px;
      .item {
        margin-top: 20px;
        height: 140px;
        background-size: cover;
        background-position: center;
        border-radius: 6px;
        img {
          width: 100%;
          height: auto;
          border-radius: 6px;
        }
      }
    }
  }


}
</style>
